var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckSymptoms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.82 17.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.62px;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "9.28 2.83 11.51 2.83 11.51 17.58 0.31 17.58 0.31 2.83 2.54 2.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.26 6.26 3.04 7.48 2.42 6.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.6,
    y1: 6.93,
    x2: 9.56,
    y2: 6.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.26 9.91 3.04 11.13 2.42 10.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.6,
    y1: 10.58,
    x2: 9.56,
    y2: 10.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.26 13.55 3.04 14.78 2.42 14.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.6,
    y1: 14.23,
    x2: 9.56,
    y2: 14.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.22,2A1.69,1.69,0,1,1,7.6,2H9.19V4H2.63V2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 5.91,
    cy: 2.06,
    r: 0.59
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSymptoms);
export default __webpack_public_path__ + "static/media/checkSymptoms.75114bd7c6690a955b5533f68543f5f4.svg";
export { ForwardRef as ReactComponent };